module.exports = __webpack_public_path__ + "img/yuyin-coupon-icon.9a21a80f.png";